import * as React from 'react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from 'use-http';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';

interface ICheckRegisterPrintTSDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onPrintTS?: (periodNo: number, office: string) => void;
    // Owned by the parent, not this dialog - mirrors the Oracle screen's own MSG status line
    // (e.g. "This period does not exist. Please try again."), populated once the parent has
    // actually tried the report call.
    message?: string;
}

// Mirrors the TE_Standard block (opened by the main screen's "Print TS" button) - just Period
// No. and Office per the real Form Builder layout. Oracle's Beg/End Date fields on this block
// are read-only, auto-filled from pay_periods purely for display and never sent to the report -
// not ported. The Destination (Printer/File/Screen) picker and its printer-select/save-as
// dialogs are dropped entirely per the confirmed web-port rule: this always just downloads a PDF.
const CheckRegisterPrintTSDialog = (props: ICheckRegisterPrintTSDialogProps) => {
    const { register, errors, getValues } = useForm();
    const { get } = useFetch();
    const [officeOptions, setOfficeOptions] = useState<Array<{ value: string; label: string }>>([]);

    useEffect(() => {
        // Deliberately not /v1.0/Landman/get-offices - that endpoint returns OFFICES.ID as its
        // "code", but CHECK_REGISTER.OFFICE (and usp_CheckRegisterTimeSheetSummary's @Office
        // param) use the 2-char OFFICE_CODE, and this dialog should only offer active offices.
        const fetchOffices = async () => {
            const result = await get('/v1.0/Payroll/offices');
            if (Array.isArray(result)) {
                setOfficeOptions(result.map((o: { code: string; dscr: string }) => ({ value: o.code, label: o.dscr })));
            }
        };
        fetchOffices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOk = () => {
        const values = getValues();
        if (props.onPrintTS) {
            props.onPrintTS(Number(values.periodNo), values.office);
        }
    };

    return (
        <Dialog title="Print Timesheets" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <RHFInputBox
                label="Period No."
                name="periodNo"
                type="number"
                register={register}
                errors={errors}
                labelOnLeft={true}
                style={{ width: 'auto' }}
            />
            <RHFSelect
                label="Office"
                name="office"
                options={officeOptions}
                register={register}
                errors={errors}
                labelOnLeft={true}
                style={{ width: '25rem' }}
            />
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '20%', marginRight: '1rem' }} text="OK" onClick={handleOk} />
                <Button className="blue-hover-button" style={{ width: '20%' }} text="Cancel" onClick={() => props.hideDialog()} />
            </div>
            <div style={{ marginTop: '1rem', minHeight: '1.2rem', textAlign: 'center', color: 'red' }}>{props.message}</div>
        </Dialog>
    );
};

export default CheckRegisterPrintTSDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/checkRegister/CheckRegisterPrintTSDialog.tsx